module.exports = __webpack_public_path__ + "img/saimage4.48a90b9a.jpg";